import { render, staticRenderFns } from "./PesquisaKitNutricional.vue?vue&type=template&id=dd682cc0&scoped=true"
import script from "./PesquisaKitNutricional.vue?vue&type=script&lang=js"
export * from "./PesquisaKitNutricional.vue?vue&type=script&lang=js"
import style0 from "./PesquisaKitNutricional.vue?vue&type=style&index=0&id=dd682cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd682cc0",
  null
  
)

export default component.exports